<template>
  <a
    :href="preview.url"
    class="help-center-post-next-article__link"
  >
    <p
      v-if="nextArticle"
      class="help-center-post-next-article__next"
    >
      See Next Article
    </p>
    <p class="help-center-post-next-article__title">
      {{ preview.title }}
    </p>
    <p
      v-if="preview.summary"
      class="help-center-post-next-article__summary"
    >
      {{ preview.summary }}
    </p>
  </a>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  post: Object,
  similarArticle: Object
})

const preview = computed(() => {
  return props.post?.next_post ?? props.similarArticle
})

const nextArticle = computed(() => {
  if (!props.similarArticle) {
    return true
  } else {
    return false
  }
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-post-next-article {
  &__link {
    @include help-center-accent-link($selector: '.help-center-post-next-article__title');
    display: block;
  }

  &__next {
    @include help-center-font(12);
    color: var(--help-center-muted);
    font-weight: var(--help-center-bold);
    text-transform: uppercase;
    margin-bottom: 8px;
  }

  &__title {
    @include help-center-font(20, title);
    color: var(--help-center-accent);
    text-wrap: balance;
    font-weight: var(--help-center-bold);
  }

  &__summary {
    @include help-center-font(14);
    color: var(--help-center-muted);
    margin-top: 8px;
  }
}
</style>
